export const FILTERS_PROVIDER_UI_REFS = {
  TRIGGER_FILTER_MENUS_BUTTON: 'TRIGGER_FILTER_MENUS_BUTTON'
};
